@if (alert && !isAlertLoading()) {
  <div
    class="alert-details border-left d-flex flex-column overflow-auto"
    [style.--header-height]="headerHeight()"
  >
    <div class="alert-data">
      <div class="h-100 mh-100 overflow-auto">
        <div class="alert-header d-flex flex-column gap-3 p-4">
          @if (entityType !== null && entity) {
            <div>
              <app-ag-tag-entity-title
                [isLink]="true"
                [fullWidth]="true"
                [entity]="entity"
                [entityType]="entityType"
              />
            </div>
          }

          <div class="alert-header-grid">
            <div class="alert-item">
              <div class="title">Date & Time</div>
              <div class="value">{{ alert.createdOn | date: 'dd MMM yyyy HH:mm' }}</div>
            </div>

            <div class="alert-item">
              <div class="title">State</div>
              <div>
                <app-ag-alerts-status
                  [status]="alert.status"
                  [isRead]="alert.isRead"
                  [postponedTill]="alert.postponedTill"
                />
              </div>
            </div>

            <div class="alert-item">
              <div class="title">Status</div>
              <div>
                <app-ag-alerts-resolved-status [resolvedStatus]="alert.resolvedStatus"/>
              </div>
            </div>
          </div>

          <div class="alert-item">
            <div class="title">Description</div>
            <div class="value">{{ alert.alertDetail.title }}</div>
          </div>
        </div>

        <div class="flex-grow-1">
          <div
            class="alert-body p-4 border-top"
            [innerHTML]="alert.alertDetail.message | insertLineBreak:'Address' | insertLineBreak:'Company'"
          ></div>

          @if (alert.type === AlertType.ValidationReport) {
            <div class="validation-message p-4 border-top font-size-14 line-height-20 font-weight-400">
              @for (error of alert.alertDetail.details; track $index) {
                <!-- <div class="title">Incorrect Addres (V444)</div> -->
                <div [class]="alert.alertDetail.isAccepted ? 'message-success' : 'message-error'">{{ error }}</div>
                <!-- <div class="recommendation">Recommendation</div> -->
              }
            </div>
          }

          @if (companiesDebtDetails.isCompanyDebtReportAsicAlertDetail) {
            <div class="alert-grid-container">
              <app-list-grid-client-side
                class="d-block w-100"
                [rowData]="companiesDebtDetails.companiesDebt"
                [colDefs]="$any(colDefs)"
                [suppressRowClickSelection]="true"
                [suppressCellFocus]="true"
                [pagination]="false"
              />
            </div>
          }

          @if (attachments?.length) {
            <div class="alert-attachments p-4 border-top">
              <div class="attachments-header d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center gap-2">
                  <span class="icon ic-paperclip-20"></span>
                  <span class="font-weight-600 font-size-14 line-height-16 color-gray-700">Attachments</span>
                </div>

                <button
                  type="button"
                  class="btn btn-secondary btn-icon"
                  (click)="downloadAllAttachments()"
                >
                  <i class="icon ic-download-20"></i>
                </button>
              </div>

              <div class="d-flex flex-column">
                @for (file of attachments; track $index) {
                  <app-file-label
                    [hideDeleteBtn]="true"
                    (downloadFile)="downloadFile(alert.id, file.name)"
                  >
                    {{ file.name }}
                  </app-file-label>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="alert-footer d-flex align-items-center gap-2 border-top px-4">
      @if (alert.status !== AlertStatus.Archived || alert.resolvedStatus === ResolvedStatus.None) {
        @for (action of alertActions; track $index) {
          <div
            class="d-flex align-items-center gap-2"
            *appHasRole="['Admin', 'Manager', 'Preparer']"
            [ngbTooltip]="action.title.length > 20 ? action.title : ''"
          >

            <button
              type="button"
              class="btn btn-primary d-flex align-items-center gap-2"
              [class.btn-loading]="isActionsDisabled()"
              [disabled]="isActionsDisabled()"
              (click)="handleAlertAction(alert, action)"
            >
              <i class="icon" [class]="action.iconClass"></i>
              <span>{{ action.title.length > 20 ? (action.title | slice:0: 20) + '...' : action.title }}</span>
            </button>
          </div>
        }
      }

      @if (isPostponeVisible) {
        <div
          ngbDropdown
          class="dropdown"
          container="body"
          [placement]="['top-start', 'top-end']"
        >
          <button
            ngbDropdownToggle
            type="button"
            id="bulk-actions-dd-2"
            class="btn btn-secondary d-flex align-items-center gap-2"
            [class.btn-loading]="isActionsDisabled()"
            [disabled]="isActionsDisabled()"
          >
            <i class="icon icon ic-clock-20"></i>
            <span>Postpone</span>
            <i class="icon ic-chevron-down-20" [hidden]="isActionsDisabled()"></i>
          </button>

          <div
            ngbDropdownMenu
            aria-labelledby="bulk-actions-dd"
            class="dropdown-menu dropdown-menu-right common-dropdown-menu"
          >
            @for (item of postponeMenu; track $index) {
              <button
                ngbDropdownItem
                (click)="postponeAlert(item.value)"
              >
                <span>{{ item.label }}</span>
              </button>
            }
          </div>
        </div>
      }

      <!-- Ignore button should be for XPM and prevent future notifications -->
      <!-- @if(alert.status !== AlertStatus.Ignored) {
        <button
            type="button"
            class="btn btn-secondary d-flex align-items-center gap-2"
            (click)="ignoreAlert()"
          >
            <i class="icon icon ic-ignore-20"></i>
            <span>Ignore</span>
          </button>
      } -->

      @if (isArchiveActionVisible) {
        <div>
          <button
            type="button"
            class="btn btn-secondary d-flex align-items-center gap-2"
            [class.btn-loading]="isActionsDisabled()"
            [disabled]="isActionsDisabled()"
            (click)="archiveAlert()"
          >
            <i class="icon ic-archive-20"></i>
            <span>Archive</span>
          </button>
        </div>
      }
    </div>
  </div>

}
